import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import endpoints from "../../content/endpoints";
import Loading from "../../assets/transparencia/Loading.js";

import "./style.sass";

const Transparencia = () => {
  const [anos, setAnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    fetch(endpoints.transparencia, { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((json) => {
        setAnos(Array.isArray(json.data) ? json.data : []);
        setError(false);
      })
      .catch((err) => {
        if (err.name === "AbortError") return;
        console.error(err);
        setError(true);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return (
    <main className="Transparencia">
      <Helmet>
        <title>Transparência Salarial | FRIBAL - Especialistas em Carne</title>
      </Helmet>
      <section className="Transparencia__content">
        <h2 className="Transparencia__title">Transparência Salarial</h2>
        <div className="Transparencia__container">
          <section className="Transparencia__intro">
            <p>
              Em atendimento ao disposto na Lei Federal nº 14.611/2023, na
              Portaria MTE Nº 3.714, bem como nos compromissos da FRIBAL para a
              promoção de práticas de inclusão e diversidade, divulgamos os
              Relatórios de Transparência Salarial e Critérios de Remuneração do
              Grupo Fribal, conforme a classificação das filiais com 100
              colaboradores ou mais.
            </p>
            <p>
              Os relatórios a seguir foram elaborados pelo Ministério do
              Trabalho e Emprego, do Governo Federal, e levaram em conta
              informações do e-Social do ano base de cada arquivo. O relatório
              utiliza uma classificação chamada “Grandes Grupos”, que reúne
              diferentes tipos de trabalho (cargos/departamentos).
            </p>
            <p>
              As informações foram divulgadas pelo Ministério do Trabalho e
              Emprego de acordo com os Grandes Grupos da CBO (Classificação
              Brasileira de Ocupações) e os dados pessoais foram protegidos, nos
              termos da Lei Geral de Proteção de Dados Pessoais (Lei Federal nº
              13.709/2018).
            </p>
          </section>

          <section className="Transparencia__files-container">
            <h3 className="Transparencia__subtitle">Documentos para download</h3>

            {loading && (
              <div className="Transparencia__loading">
                <Loading label="Carregando documentos" />
              </div>
            )}
            {error && !loading && (
              <p>Não foi possível carregar os documentos. Tente novamente mais tarde.</p>
            )}

            {anos.map((ano, anoIndex) => (
              <React.Fragment key={ano.id}>
                <h4 className="Transparencia__ano">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    title={ano.arquivo_url?.split("/").pop()}
                    href={ano.arquivo_url}
                  >
                    {ano.ano}
                  </a>
                </h4>

                {ano.periodos?.map((periodo) => (
                  <div key={periodo.id} className="Transparencia__files">
                    <h5 className="Transparencia__semestre">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        title={periodo.arquivo_url?.split("/").pop()}
                        href={periodo.arquivo_url}
                      >
                        {periodo.titulo}
                      </a>
                    </h5>
                
                    {periodo.itens?.map((item) => (
                      <a
                        key={item.id}
                        className="Transparencia__arquivo"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={item.arquivo_url}
                      >
                        <span className="Transparencia__nome">{item.titulo}</span>
                        <time className="Transparencia__data" dateTime={item.publicacao}>
                          Publicado em {item.publicacao_label}
                        </time>
                      </a>
                    ))}
                  </div>
                ))}

                {anoIndex < anos.length - 1 && (
                  <i className="Transparencia__separador" />
                )}
              </React.Fragment>
            ))}
          </section>
        </div>
      </section>
    </main>
  );
};

export default Transparencia;